import { StorefrontOutlined } from "@mui/icons-material";
import { Box, Card, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

export default function MerchantAdminLayout({ children }: PropsWithChildren<{}>) {
  return (
    <Box display={"flex"} mt={4}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          width: "100%",
          minHeight: 600,
          mb: 2,
          borderRadius: 3,
          border: "1px solid #ECECEC",
        }}
      >
        <Box display="flex" flexDirection={"column"} sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: "1px solid #ECECEC",
              p: { xs: 2.5, sm: 3 },
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  bgcolor: purpleLight,
                  flexShrink: 0,
                }}
              >
                <StorefrontOutlined sx={{ color: purple, fontSize: 24 }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700} color={black}>
                  Merchants
                </Typography>
                <Typography variant="body2" color={greyEnabled}>
                  Manage merchants and their vouchers.
                </Typography>
              </Box>
            </Box>
          </Box>
          {children}
        </Box>
      </Card>
    </Box>
  );
}
